import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';


function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.store_name}
        </TableCell>
        <TableCell align="left">{row.sales}</TableCell>
        <TableCell align="left">{row.budget}</TableCell>
        <TableCell align="left">{row.trans_count}</TableCell>
        <TableCell align="left">{row.percent}</TableCell>
        <TableCell align="left">{row.sale_average}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                History
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Sales</TableCell>
                    <TableCell align="left">Budget</TableCell>
                    <TableCell align="left"> Transactions</TableCell>
                    <TableCell align="left">  %</TableCell>
                    <TableCell align="left"> Average</TableCell>
                    <TableCell align="left"> Opened</TableCell>
                    <TableCell align="left"> First</TableCell>
                    <TableCell align="left"> Latest</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.details.map((detailsRow) => (
                    <TableRow key={detailsRow.date}>
                      <TableCell component="th" scope="row">
                        {detailsRow.date}
                      </TableCell>
                      <TableCell>{detailsRow.sales}</TableCell>
                      <TableCell align="left">{detailsRow.budget}</TableCell>
                      <TableCell align="left">
                        {detailsRow.trans_count}
                      </TableCell>
                      <TableCell align="left">
                        {detailsRow.percent}
                      </TableCell>
                      <TableCell align="left">
                        {detailsRow.sale_average}
                      </TableCell>
                      <TableCell align="left">
                        {detailsRow.opened_at}
                      </TableCell>
                      <TableCell align="left">
                        {detailsRow.first_transaction}
                      </TableCell>
                      <TableCell align="left">
                        {detailsRow.latest_transaction}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


export default function ReportTable({rows}) {

  //console.log(rows)
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell> Store </TableCell>
            <TableCell align="left">Sales</TableCell>
            <TableCell align="left"> Budget</TableCell>
            <TableCell align="left"> Transactions</TableCell>
            <TableCell align="left">Percent</TableCell>
            <TableCell align="left">Average</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <Row key={row.sales} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}